module.exports = __webpack_public_path__ + "catalog/items/curved-based-unit/curved-based-unit.svg";